import { isUndefinedOrEmpty } from '@afterpay/utils/string'

interface AnonymousErrorPayload {
  httpStatus?: string
  responseHeaders?: string
  internalErrorMessage?: string
  requestUrl?: string
  kasadaBlocked?: boolean
}

const WHITELISTED_HEADERS = ['http_correlation_id', 'cf-ray']

const KASADA_RESPONSE_BODY_REGEX = /KPSDK/

/**
 * Gets a payload for Amplitude logging, based on errors most commonly associated
 * with login and lookup.
 * @param error
 * @returns void
 */
export const getAnonymousErrorPayload = (error?: any): AnonymousErrorPayload => {
  const axiosHeaders = Object.fromEntries(
    Object.entries(error?.responseHeaders ?? {}).map(([key, value]) => (WHITELISTED_HEADERS.includes(key.toLowerCase()) ? [key, value] : []))
  )

  const kasadaBlocked = KASADA_RESPONSE_BODY_REGEX.test(error?.responseData)

  return {
    httpStatus: error?.status,
    responseHeaders: JSON.stringify({ ...axiosHeaders }),
    internalErrorMessage: error?.message,
    requestUrl: error?.requestUrl,
    ...(!isUndefinedOrEmpty(error?.responseData) && { kasadaBlocked }),
  }
}
